import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
export class FormValidatorsService {
    /**
     * Only ASCII characters are allowed
     * @param control From control
     * @returns Validation result value
     */
    static asciiValidator() {
        return (control) => {
            if (control.value === null ||
                control.value === undefined ||
                control.value.length === 0) {
                return null;
            }
            if (FormValidatorsService.findNonASCIISymbol(control.value) !== -1) {
                return { ascii: true };
            }
            return null;
        };
    }
    /**
     * Find non ASCII symbol
     * @param str String, to be checked for a non-ASCII character
     * @returns The return value is the index of the non-ASCII character,
     * or, if there are no non-ASCII characters in the string
     */
    static findNonASCIISymbol(str) {
        for (let i = 0; i < str.length; i++) {
            const asciiNum = str.charCodeAt(i);
            if (FormValidatorsService.isNonASCIISymbol(asciiNum)) {
                return i;
            }
        }
        return -1;
    }
    /**
     * Check if symbol non ASCII symbol
     * @param asciiNum Ascii number value
     * @returns Result if any ascii is not allowed
     */
    static isNonASCIISymbol(asciiNum) {
        const wsChars = [
            9,
            10,
            11,
            12,
            13, // Carriage return
        ];
        /**
         * * Definition of white space chars which are control symbols.
         * */
        const whiteSpace = function (character) {
            let isWhiteSpace = false;
            for (let k = 0; k < wsChars.length; k++) {
                if (character === wsChars[k]) {
                    isWhiteSpace = true;
                }
            }
            return isWhiteSpace;
        };
        return (asciiNum < 32 && !whiteSpace(asciiNum)) || asciiNum > 126;
    }
    static supportedExtensionFileValidator(validExtensions) {
        const extensions = validExtensions;
        return (control) => {
            let valid = true;
            const value = control.value;
            const checkPredicate = (file) => {
                const extMatch = file.name.match(/.[A-Za-z0-9]+$/);
                if (extMatch.length === 1) {
                    const ext = extMatch[0].toLowerCase();
                    return extensions.indexOf(ext.substring(1, ext.length)) > -1;
                }
                return true;
            };
            if (value instanceof Array) {
                value.forEach((file) => (valid = valid && checkPredicate(file)));
            }
            else if (value) {
                valid = checkPredicate(value);
            }
            return valid
                ? null
                : { notValidExtension: { validExtensions: extensions.join(', ') } };
        };
    }
    static supportedSizeFileValidator(validMaxSizeInMb) {
        const ONE_MB_IN_BYTES = 1048576;
        const maxSizeInMb = validMaxSizeInMb;
        return (control) => {
            let maxSizeValid = true;
            let emptyFileValid = true;
            const value = control.value;
            const checkMaxSizePredicate = (file) => file.size <= maxSizeInMb * ONE_MB_IN_BYTES;
            const checkEmptyFilePredicate = (file) => file.size !== 0;
            if (value instanceof Array) {
                value.forEach((file) => {
                    maxSizeValid = maxSizeValid && checkMaxSizePredicate(file);
                    emptyFileValid = emptyFileValid && checkEmptyFilePredicate(file);
                });
            }
            else if (value) {
                maxSizeValid = checkMaxSizePredicate(value);
                emptyFileValid = checkEmptyFilePredicate(value);
            }
            if (!maxSizeValid) {
                return { maxiFileSizeExceeded: { maxSizeInMb } };
            }
            if (!emptyFileValid) {
                return { emptyFile: { maxSizeInMb } };
            }
            return null;
        };
    }
    static phoneNumberValidator() {
        return (control) => {
            const value = control.value;
            if (!value) {
                return null;
            }
            // const regex = /^(?:\+)?(?:\d[\s()-]*x?){10,}\d*$/;
            const regex = /^[+]?([xX() -]*\d){10,}[xX() -]*$/;
            const phLength = value.replace(/\D/g, '').length;
            //const isValid = regex.test(value) && phLength >= 10 && phLength <= 40;
            const isValid = regex.test(value) && phLength >= 10 && phLength <= 40;
            return !isValid ? { phoneNumberInvalid: true } : null;
        };
    }
    static startTimeBeforeEndTimeValidator() {
        return (control) => {
            if (control.value) {
                let endTimeMoment;
                let startTime = control.value;
                if (startTime?.code) {
                    startTime = startTime.code;
                }
                const startTimeMoment = new Date();
                startTimeMoment.setHours(Number(startTime.split(':')[0]));
                startTimeMoment.setMinutes(Number(startTime.split(':')[1]));
                if (control.parent?.controls['endTime']?.valid) {
                    let endTime = control.parent.controls['endTime'].value;
                    if (endTime?.code) {
                        endTime = endTime.code;
                    }
                    endTimeMoment = new Date();
                    endTimeMoment.setHours(Number(endTime.split(':')[0]));
                    endTimeMoment.setMinutes(Number(endTime.split(':')[1]));
                }
                else {
                    // endTimeMoment = new Date();
                    return null;
                }
                if (startTimeMoment > endTimeMoment) {
                    return { startTimeBeforeEndTime: true };
                }
            }
            return null;
        };
    }
    static timeFormateValidator() {
        return (control) => {
            const controlVal = control.value;
            if (!controlVal || typeof controlVal === 'object')
                return null;
            if (controlVal) {
                const valSplitBySpace = controlVal.split(' ');
                const valSplitByColon = valSplitBySpace?.[0]?.split(':');
                const isValidTimeMeridian = valSplitBySpace?.[1]?.length === 2 &&
                    (valSplitBySpace?.[1] === 'AM' || valSplitBySpace?.[1] === 'PM');
                if (controlVal.includes('-') ||
                    !controlVal.includes(' ') ||
                    !valSplitBySpace?.[0]?.includes(':') ||
                    controlVal.length < 7 ||
                    controlVal.length > 8 ||
                    valSplitByColon[0] === '00' ||
                    valSplitByColon[0] === '0' ||
                    (valSplitByColon?.[0]?.length === 1 && controlVal.length !== 7) ||
                    (valSplitByColon?.[0]?.length === 2 && controlVal.length !== 8) ||
                    !isValidTimeMeridian ||
                    parseInt(valSplitByColon?.[1]) >= 60 ||
                    parseInt(valSplitByColon?.[0]) > 12)
                    return { timeControlValid: false };
                return null;
            }
            return null;
        };
    }
    static { this.ɵfac = function FormValidatorsService_Factory(t) { return new (t || FormValidatorsService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FormValidatorsService, factory: FormValidatorsService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormValidatorsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();
